import { useContext } from "react";
import { IntlContext } from "../components/IntlContext";

export const useIntl = () => {
  const intl = useContext(IntlContext);

  return intl;
}
